/* Mantiene las tablas nativas y limita su desplazamiento al bloque de lectura. */
(() => {
  'use strict';
  function preparar() {
    document.querySelectorAll(':is(.hs-lectura,.shopify-policy__container) table').forEach(tabla => {
      if (tabla.parentElement.classList.contains('hs-lectura__tabla')) return;
      const contenedor = document.createElement('div');
      contenedor.className = 'hs-lectura__tabla';
      contenedor.tabIndex = 0;
      contenedor.setAttribute('role', 'region');
      contenedor.setAttribute('aria-label', 'Tabla con desplazamiento horizontal');
      tabla.before(contenedor);
      contenedor.append(tabla);
    });
  }
  preparar();
  document.addEventListener('shopify:section:load', preparar);
  document.addEventListener('contentUpdated', preparar);
})();
